/**
 * Application entry point
 */

import './styles/global.css';
import './components/app-root.js';
import { databaseService } from './services/database.js';
import { timerService } from './services/timer.js';
import { audioService } from './services/audio.js';
import { leaderElection } from './services/leader-election.js';

// Initialize the application
async function init() {
  try {
    console.log('Initializing Full Life Pomodoro...');

    // Initialize leader election
    leaderElection.initialize();
    console.log('Leader election initialized');

    // Initialize database
    await databaseService.initialize();
    console.log('Database ready');

    // Load app state and apply volume
    const appState = await databaseService.getAppState();
    audioService.setVolume(appState.settings.soundVolume);

    // Preload alert sound
    await audioService.preloadSound();
    console.log('Audio preloaded');

    // Start timer service
    timerService.start();
    console.log('Timer started');

    console.log('Application initialized successfully');
  } catch (error) {
    console.error('Failed to initialize application:', error);
  }
}

// Start the app
init();
